import { IBookingManagerHotelDetailsSubdomain } from './types';
import { initialState } from './model';
import { ENetworkRequestStatus } from 'services/BackendApi/types/Generic';
import * as Actions from './actions';
import { produce } from 'immer';

const financeReducer = (
  state: IBookingManagerHotelDetailsSubdomain = initialState,
  action: Actions.HotelDetailsAction
) => {
  switch (action.type) {
    case Actions.GET_HOTEL_DETAILS_REQUEST:
      return produce(state, draft => {
        draft.networkRequests.hotelDetailsLoad = ENetworkRequestStatus.PENDING;
        return draft;
      });
    case Actions.GET_HOTEL_DETAILS_SUCCESS:
      return produce(state, draft => {
        draft.networkRequests.hotelDetailsLoad = ENetworkRequestStatus.SUCCESS;
        draft.hotelDetails = action.hotelDetails;
        return draft;
      });
    case Actions.GET_HOTEL_DETAILS_FAILURE:
      return produce(state, draft => {
        draft.networkRequests.hotelDetailsLoad = ENetworkRequestStatus.ERROR;
        return draft;
      });

    case Actions.SET_RESORT_CONFIRMATION_NUMBER:
      return produce(state, draft => {
        const { hotelUuid, resortConfirmationNumber } = action;
        draft.hotelDetails = draft.hotelDetails.map(hotel => {
          if (hotel.uuid === hotelUuid) {
            return {
              ...hotel,
              resortConfirmationNumber,
            };
          }
          return hotel;
        });
      });

    case Actions.HANDLE_REMOVE_ACCOMMODATION:
      return produce(state, draft => {
        draft.hotelDetails = draft.hotelDetails.filter(hotel => action.hotelUuidsRemaining.includes(hotel.uuid));
        return draft;
      });

    case Actions.SET_HOTEL_DETAILS:
      return produce(state, draft => {
        draft.hotelDetails = action.hotelDetails;
        return draft;
      });

    default:
      return state;
  }
};

export default financeReducer;
